import React from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button';
import Column from '~/Common-Objects/Grids/Column/Column';
import DataTable1 from '~/Common-Objects/Tables/DataTable1/DataTable1';
import Icons from '~/Common-Objects/UI/Icons/index';
import Paper from '~/Common-Objects/UI/Paper/Paper';
import Row from '~/Common-Objects/Grids/Row/Row';
import i18n from '~/i18n';
export default class CampaignTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return <Paper className="m-mar-b0" iconRight={<Icons icon="pencil" color="grey" />} iconRightClick={this.props.edit}>
            <div className="quickFlex mar-b24" style={{ justifyContent: "space-between" }}>
                <h4>{i18n.t('dashboard:welcomePage.mostRecentCampaigns')}</h4>
                {!!this.props.campaigns.length && <Row>
                    <Column xs={12} margin={0} className="end-xs">
                        <Button className="primary" iconRight={<Icons icon="arrowRight" />} onClick={() => this.props.history.push('/cp/campaigns')}>{i18n.t('campaigns:main.tooltip')}</Button>
                    </Column>
                </Row>}
            </div>
            <Row className="mar-b20">
                <Column xs={12} margin={0}>

                    <DataTable1
                        noResultsTxt={this.props.canCreateCampaigns ? <span> {i18n.t('campaigns:main.noCampaignsFound')} {i18n.t('campaigns:main.addCampaign')} - <a onClick={this.props.addCampaign}>{i18n.t('create')}</a></span> : i18n.t('campaigns:main.noCampaignsFound2')}
                        tableData={this.props.campaigns}
                        width="100%"
                        pageSize="5"
                        hasCheckBoxes="no"
                        hideHeader={true}
                    />
                </Column>
            </Row>

        </Paper>
    };
};
